const TopBarMode = {
  MENU: 'menu',
  CONTENT: 'content',
};

export { TopBarMode };
